import { Pagination, Table } from "antd";
import { getLeaveType } from "api/services/common";
import {
    exportLeaveListApi,
    getLeaveDetail,
    getLeaveList,
    getLeaveSummary,
} from "api/services/leave";
import { Button } from "components/Button";
import FilterDrawer from "components/Drawer/leaveFilterDrawer";
import Image from "components/Image";
import { SkeltonLoader } from "components/skeltonLoader";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { filterHandler, formatDateHandler2 } from "utils/common";
import { primaryRedGradient } from "utils/constants";
import {
    defaultPagination,
    handlePageChange,
    itemRender,
    pageSizeOptions,
} from "utils/table";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import EmployeeLeaveModelPopup from "../../../../components/modelpopup/EmployeeLeaveModelPopup";
import EmployeeLeaveFilter from "../components/employeeLeaveFilter";
import useEmployeeLeaveFilter from "../hooks/filterLeaveHook";

const EmployeeLeave = () => {
  const [leaveSummary, setLeaveSummary] = useState({});
  const [users, setUsers] = useState([]);
  const [leaves, setLeaves] = useState([]);
  const [leavesLoading, setLeavesLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [leaveModal, setLeaveModal] = useState(false);

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const [selectedLeave, setSelectedLeave] = useState("");
  const [appliedFilterCount, setAppliedFilterCount] = useState(0);
  const [expandedComments, setExpandedComments] = useState({});

  const [view, setView] = useState(isMobile ? "grid" : "list");
  const { user, userLoading } = useSelector((state) => state.user);

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const getFilterParams = useCallback(() => {
    let filter_params = filterHandler(filters);

    return filter_params;
  });

  useEffect(() => {
    // console.log(id, modal, "MMM")
    const id = queryParams.get("id"); // Get 'id' param
    const modal = queryParams.get("modal"); // Get 'name' param
    // const { search } = useLocation();
    // const queryParams = new URLSearchParams(location?.search);
    console.log(queryParams, id, modal, queryParams, "MMM");

    if (id && modal) {
      getLeaveDetail(id, {}).then((response) => {
        console.log(response.data, "LLLL");
        handleLeaveAction(response.data);
      });
    }
  }, []);
  useEffect(() => {
    getLeaveType().then((res) => {
      setLeaveTypes(
        res.data.results.map((item) => {
          return {
            label: `${item.description}`,
            value: item.id,
            code: item.code // Preserve code for filtering logic
          };
        })
      );
    });
  }, []);

  const navigate = useNavigate();

  const [pageSettings, setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",
  });

  const wrapText = (text, maxLength = 15) => {
    if (!text) return "";
    return text.match(new RegExp(`.{1,${maxLength}}`, "g")).join("\n");
  };

  const {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading,
    setFilterLoading,
    handleDateChange,
  } = useEmployeeLeaveFilter(pageSettings, setPageSettings);

  useEffect(() => {
    // axios
    //   .get(base_url + "/api/adminleaves.json")
    //   .then((res) => setUsers(res.data));

    getLeaveSummary().then((res) => {
      console.log(res.data, "DATAAAA");
      setLeaveSummary(res.data);
    });
  }, []);

  const fetchLeaveList = () => {
    setLoading(true);
    setLeavesLoading(true);
    let filter_params = getFilterParams();
    getLeaveList({
      sort_by: pageSettings?.sortBy,
      sort_type: pageSettings?.sortType,
      page_size: pageSettings?.pageSize,
      page: pageSettings?.page,
      ...filter_params,
    })
      .then((res) => {
        setPageSettings({
          ...pageSettings,
          total: res.data.count
        })
        if (view == "grid" && pageSettings?.page !== 1) {
          setLeaves([...leaves, ...res.data.results]);
        } else {
          setLeaves(res.data.results);
        }

        setLoading(false);
        setShowFilterDrawer(false);
        setLeavesLoading(false);
      })
      .catch((e) => {
        setLeaves([]);
        setLoading(false);
        setLeavesLoading(false);
      });
  };
  useEffect(() => {
    fetchLeaveList();
  }, [
    pageSettings?.page,
    pageSettings?.pageSize,
    pageSettings?.sortBy,
    pageSettings?.sortType,
    pageSettings?.filters,
  ]);

  const handleLeaveAction = (record) => {
    setSelectedLeave(record);
    setLeaveModal(true);
  };

  const columns = [
    // {
    //   title: "ID",
    //   dataIndex: "id",
    //   sorter: true,
    // },
    {
      title: "Name",
      dataIndex: "company_user__first_name",
      sorter: true,
      render: (text, record, index) => (
        <h2
          onClick={() => handleLeaveAction(record)}
          className="table-avatar d-flex"
        >
          <a className="avatar">
            {/* <img alt="" src={record.profile_image} /> */}
            <Image
              src={record?.company_user?.profile_image}
              type="user"
              style={{ objectFit: "cover" }}
            />
          </a>
          <div>
            <a
              // onClick={()=>handleEmployeeDetailPage(record.id, index)}
              className="profile-split d-flex flex-column"
            >
              {record.company_user?.first_name}{" "}
              {record?.company_user?.last_name}
            </a>
            {record?.company_user?.emp_no && (
              <span className="small text-muted">
                {record.company_user?.emp_no}
              </span>
            )}
          </div>
        </h2>
      ),
    },
    // {
    //   title: "Position",
    //   dataIndex: "position_name",
    //   // sorter: true,
    //   render: (text, record, index) => (
    //       <span>{record?.company_user?.position_name}</span>

    //   ),
    //   align:"center"

    // },
    {
      title: "Leave Type",
      dataIndex: "leave_type__code",
      render: (text, record) => <span>{record?.leave_type?.description}</span>,
      sorter: true,
    },
    {
      title: "Created On",
      dataIndex: "created_at",
      render: (text, record) => <span>{formatDateHandler2(text)}</span>,
      sorter: true,
    },

    {
      title: "From",
      dataIndex: "start_date",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter: true,
      align: "center",
    },
    {
      title: "To",
      dataIndex: "end_date",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter: true,
      align: "center",
    },

    {
      title: "Total Days",
      dataIndex: "no_of_days",
      render: (text) => <span>{text}</span>,
      // sorter: true,
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "approval_status",
      sorter: true,
      render: (text) => (
        <div className="dropdown action-label text-center">
          <span
            className={`badge badge-soft-${
              (text == "pending" || text == "cancel_pending")
                ? "warning"
                : text == "rejected"
                ? "danger"
                : "success"
            }`}
          >
            {text.replace("_", " ")}
          </span>
        </div>
      ),
    },
    {
      title: "Cost Center",
      dataIndex: "company_user__cost_center",
      render: (text, record) => <span>{record?.cost_center?.code || ""}</span>,
      sorter: true,
      align: "center",
    },
    {
      title: "Current Approver",
      // dataIndex: "approved_by",
      dataIndex: "current_approver__first_name",
      sorter: true,
      render: (text, record) => (
        <h2 className="table-avatar d-flex">
          {record?.current_approver && (
            <>
              <a
                // onClick={()=>handleEmployeeDetailPage(record.id, index)}
                className="avatar"
              >
                {/* <img alt="" src={record.profile_image} /> */}
                <Image
                  src={record?.current_approver?.profile_image}
                  type="user"
                  style={{ objectFit: "cover" }}
                />
              </a>
              <a
                // onClick={()=>handleEmployeeDetailPage(record.id, index)}
                className="profile-split d-flex flex-column"
              >
                {record.current_approver?.first_name}{" "}
                {record?.current_approver?.last_name}
                {record?.current_approver?.emp_no && (
                  <span className="small text-muted">
                    {record.current_approver.emp_no}
                  </span>
                )}
              </a>
            </>
          )}
        </h2>
      ),
    },
    {
      title: "Approved on",
      dataIndex: "approved_on",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter: true,
    },
    {
      title: "Role Delegation",
      dataIndex: "role_delegation__first_name",
      sorter: true,
      render: (text, record, index) => (
        <h2 className="table-avatar d-flex">
          {record?.role_delegation && (
            <>
              <a className="avatar">
                {/* <img alt="" src={record.profile_image} /> */}
                <Image
                  src={record?.role_delegation?.profile_image}
                  type="user"
                  style={{ objectFit: "cover" }}
                />
              </a>
              <div>
                <a
                  // onClick={()=>handleEmployeeDetailPage(record.id, index)}
                  className="profile-split d-flex flex-column"
                >
                  {record.role_delegation?.first_name}{" "}
                  {record?.role_delegation?.last_name}
                </a>
                {record?.role_delegation?.emp_no && (
                  <span className="small text-muted">
                    {record.role_delegation?.emp_no}
                  </span>
                )}
              </div>
            </>
          )}
        </h2>
      ),
    },
      {
        title: "Comments",
        dataIndex: "comment",
        sorter: true,
        width: 300,
        render: (text, record) => {
          if (!text || text.trim() === "") {
            return null;
          }
          
          const isExpanded = expandedComments[record.id];
          const maxLength = 100;
          const shouldTruncate = text && text.length > maxLength;
          const displayText = isExpanded || !shouldTruncate ? text : `${text.substring(0, maxLength)}...`;
          
          return (
            <div style={{ maxWidth: "300px", wordWrap: "break-word" }}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
                <span
                  style={{
                    flex: 1,
                    whiteSpace: isExpanded ? "pre-wrap" : "normal",
                    wordBreak: "break-word",
                    overflow: isExpanded ? "visible" : "hidden",
                    textOverflow: isExpanded ? "clip" : "ellipsis",
                    lineHeight: "1.5",
                    display: isExpanded ? "block" : "-webkit-box",
                    WebkitLineClamp: isExpanded ? "none" : 3,
                    WebkitBoxOrient: "vertical"
                  }}
                >
                  {displayText}
                </span>
                {shouldTruncate && (
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setExpandedComments(prev => ({
                        ...prev,
                        [record.id]: !prev[record.id]
                      }));
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#667eea",
                      cursor: "pointer",
                      padding: "4px",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      borderRadius: "4px",
                      transition: "background-color 0.2s"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "rgba(102, 126, 234, 0.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }}
                    title={isExpanded ? "Collapse" : "Expand"}
                  >
                    <i className={`fa ${isExpanded ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                  </button>
                )}
              </div>
            </div>
          );
        },
      },
    {
      title: "Attachments",
      dataIndex: "attachments",
      render: (text, record) => {
        let str =
          record.attachments.length == 1 ? " Attachment" : " Attachments";
        return (
          <>
            <span className="file-attached">
              <i className="fa fa-paperclip" />
            </span>
            {" " + record.attachments.length + str}
          </>
        );
      },
      sorter: true,
      align: "center",
    },
    {
      title: "Action",
      className: "text-end",
      sorter: true,
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              onClick={() => handleLeaveAction(record)}
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            {/* <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete"
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </Link> */}
          </div>
        </div>
      ),
    },
  ];
  const leaveStats = [
    {
      id: 1,
      title: "Annual Leave",
      value: 12,
    },
    {
      id: 2,
      title: "Medical Leave",
      value: 3,
    },
    {
      id: 3,
      title: "Other Leave",
      value: 4,
    },
    {
      id: 4,
      title: "Remaining Leave",
      value: 5,
    },
  ];
  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings);
    console.log(pageData);
    // setSearchParams({
    //     size: pageData?.pageSize,
    //     page: pageData?.page,
    //     sort_by: pageData?.sortBy || "",
    //     sort_type: pageData?.sortType || ""
    // })
    setPageSettings(pageData);
  };

  const handleFilterDrawer = () => {
    console.log("JJJJJJJ");
    setShowFilterDrawer(!showFilterDrawer);
    setFilterLoading(false);
  };

  const handleApplyFilter = () => {
    let _appliedFilters = filters.filter(
      (item) => item.value && item.key != "search"
    );
    setAppliedFilterCount(_appliedFilters.length);

    // setFilterLoading(true)
    setPageSettings({
      ...pageSettings,
      page: 1,
      filters,
    });
    // getEmployeeList()
  };

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {leaves.map((record, index) => (
            <div
              className="col-12 col-sm-6 col-md-4 col-lg-3"
              key={record.id}
              style={{
                ...(isMobile ? { paddingLeft: "4px", paddingRight: "4px", marginBottom: "12px" } : { marginBottom: "16px" }),
                display: "flex"
              }}
            >
              <div className="card shadow-sm" style={{ 
                borderRadius: "8px", 
                border: "none",
                background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
                margin: 0,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                position: "relative",
                overflow: "hidden",
                cursor: "pointer",
                transition: "all 0.2s ease",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
              }}
              onClick={() => handleLeaveAction(record)}
              >
                <div className="card-body" style={{ 
                  padding: isMobile ? "12px" : "16px",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column"
                }}>
                  {/* User Avatar and Name */}
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "12px"
                  }}>
                    <div style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "2px solid #e5e7eb",
                      flexShrink: 0,
                      background: "#ffffff"
                    }}>
                      <Image
                        src={record.company_user?.profile_image}
                        type="user"
                        alt="User Image"
                        style={{ 
                          objectFit: "cover",
                          width: "100%",
                          height: "100%"
                        }}
                      />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ 
                        fontSize: "13px", 
                        color: "#1f2937",
                        fontWeight: "600",
                        marginBottom: "2px"
                      }}>
                        {record.company_user?.first_name}{" "}
                        {record?.company_user?.last_name}
                      </div>
                      {record.company_user?.emp_no && (
                        <div style={{ 
                          fontSize: "11px", 
                          color: "#6b7280",
                          marginBottom: "2px"
                        }}>
                          {record.company_user.emp_no}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Leave Details */}
                  <div style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column"
                  }}>
                    <div className="row g-2" style={{ marginBottom: "10px" }}>
                      {record?.start_date && (
                        <div className="col-6">
                          <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "3px", fontWeight: "500" }}>
                            <i className="la la-calendar" style={{ marginRight: "4px" }}></i>
                            From
                          </div>
                          <div style={{ fontSize: "11px", color: "#374151", fontWeight: "500" }}>
                            {formatDateHandler2(record.start_date)}
                          </div>
                        </div>
                      )}
                      {record?.end_date && (
                        <div className="col-6">
                          <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "3px", fontWeight: "500" }}>
                            <i className="la la-calendar-check" style={{ marginRight: "4px" }}></i>
                            To
                          </div>
                          <div style={{ fontSize: "11px", color: "#374151", fontWeight: "500" }}>
                            {formatDateHandler2(record.end_date)}
                          </div>
                        </div>
                      )}
                      {record?.no_of_days && (
                        <div className="col-6">
                          <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "3px", fontWeight: "500" }}>
                            <i className="la la-calendar-week" style={{ marginRight: "4px" }}></i>
                            Days
                          </div>
                          <div style={{ fontSize: "11px", color: "#374151", fontWeight: "500" }}>
                            {record.no_of_days}
                          </div>
                        </div>
                      )}
                      {record?.leave_type?.description && (
                        <div className="col-6">
                          <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "3px", fontWeight: "500" }}>
                            <i className="la la-file-text" style={{ marginRight: "4px" }}></i>
                            Type
                          </div>
                          <div style={{ fontSize: "11px", color: "#374151", fontWeight: "500" }}>
                            {record.leave_type.description}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Cost Center and Status Badge on same line */}
                    <div style={{
                      marginBottom: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "8px",
                      flexWrap: "wrap"
                    }}>
                      {record?.cost_center?.code && (
                        <div style={{ 
                          fontSize: "10px",
                          color: "#6b7280",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px"
                        }}>
                          <span style={{ color: "#9ca3af" }}>CC:</span>
                          <span>{record.cost_center.code}</span>
                        </div>
                      )}
                      {record?.approval_status && (
                        <span
                          className={`badge badge-soft-${
                            record?.approval_status == "pending" || record?.approval_status == "cancel_pending"
                              ? "warning"
                              : record?.approval_status == "rejected" || record?.approval_status == "cancel_rejected"
                              ? "danger"
                              : "success"
                          }`}
                          style={{
                            fontSize: "10px",
                            fontWeight: "600",
                            padding: "3px 6px",
                            borderRadius: "4px"
                          }}
                        >
                          {record.approval_status.replace("_", " ")}
                        </span>
                      )}
                    </div>

                    {/* Current Approver */}
                    {record?.current_approver && (
                      <div style={{
                        marginTop: "auto",
                        paddingTop: "10px",
                        borderTop: "1px solid #e5e7eb"
                      }}>
                        <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "3px", fontWeight: "500" }}>
                          <i className="la la-user" style={{ marginRight: "4px" }}></i>
                          Current Approver
                        </div>
                        <div style={{ fontSize: "11px", color: "#374151", fontWeight: "500" }}>
                          {record.current_approver.first_name}{" "}
                          {record.current_approver.last_name}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  const handleGridChange = (page, size) => {
    console.log(page, size, ")))))))))))))");
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    });
    // setSearchParams({
    //     size,
    //     page,
    // })
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Leaves"
            title="Dashboard"
            subtitle="Leaves"
            modal="#add_leave"
            name="Apply Leave"
            setLeaveModal={setLeaveModal}
            // hideGrid={true}
            view={view}
            setView={setView}
          />

          <div className="row g-3 mb-4" style={{ display: "flex", flexWrap: "wrap" }}>
            <style>{`
              @media (max-width: 768px) {
                .row.g-3 > * {
                  padding-right: calc(var(--bs-gutter-x) * 0.25) !important;
                  padding-left: calc(var(--bs-gutter-x) * 0.25) !important;
                  margin-bottom: 0.5rem !important;
                }
                .row.g-3 {
                  --bs-gutter-x: 0.5rem;
                  --bs-gutter-y: 0.5rem;
                }
              }
            `}</style>
            <div className="col-md-3 col-sm-6" style={{ display: "flex" }}>
              <div 
                className="card shadow-sm"
                style={{
                  borderRadius: "12px",
                  border: "none",
                  background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                  color: "#ffffff",
                  overflow: "hidden",
                  position: "relative",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  cursor: "pointer",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 8px 16px rgba(16, 185, 129, 0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
                }}
              >
                <div style={{ position: "absolute", top: "-15px", right: "-15px", width: "80px", height: "80px", background: "rgba(255, 255, 255, 0.1)", borderRadius: "50%" }}></div>
                <div className="card-body p-3" style={{ position: "relative", zIndex: 1, flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div style={{ flex: 1 }}>
                      <h6 
                        style={{
                          fontSize: "11px",
                          fontWeight: "600",
                          color: "rgba(255, 255, 255, 0.85)",
                          marginBottom: "6px",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px"
                        }}
                      >
                        Planned Leave Today
                      </h6>
                      <h4 
                        style={{
                          fontSize: "28px",
                          fontWeight: "700",
                          color: "#ffffff",
                          marginBottom: 0,
                          lineHeight: "1.1"
                        }}
                      >
                        {leaveSummary?.planned_leaves_today || 0}
                      </h4>
                    </div>
                    <div 
                      style={{
                        width: "44px",
                        height: "44px",
                        borderRadius: "10px",
                        background: "rgba(255, 255, 255, 0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backdropFilter: "blur(10px)",
                        flexShrink: 0,
                        marginLeft: "12px"
                      }}
                    >
                      <i className="fa fa-check-circle" style={{ fontSize: "20px", color: "#ffffff" }}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6" style={{ display: "flex" }}>
              <div 
                className="card shadow-sm"
                style={{
                  borderRadius: "12px",
                  border: "none",
                  background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
                  color: "#ffffff",
                  overflow: "hidden",
                  position: "relative",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  cursor: "pointer",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 8px 16px rgba(139, 92, 246, 0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
                }}
              >
                <div style={{ position: "absolute", top: "-15px", right: "-15px", width: "80px", height: "80px", background: "rgba(255, 255, 255, 0.1)", borderRadius: "50%" }}></div>
                <div className="card-body p-3" style={{ position: "relative", zIndex: 1, flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div style={{ flex: 1 }}>
                      <h6 
                        style={{
                          fontSize: "11px",
                          fontWeight: "600",
                          color: "rgba(255, 255, 255, 0.85)",
                          marginBottom: "6px",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px"
                        }}
                      >
                        Planned Leave This Week
                      </h6>
                      <h4 
                        style={{
                          fontSize: "28px",
                          fontWeight: "700",
                          color: "#ffffff",
                          marginBottom: 0,
                          lineHeight: "1.1"
                        }}
                      >
                        {leaveSummary?.planned_leaves_this_week || 0}
                      </h4>
                    </div>
                    <div 
                      style={{
                        width: "44px",
                        height: "44px",
                        borderRadius: "10px",
                        background: "rgba(255, 255, 255, 0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backdropFilter: "blur(10px)",
                        flexShrink: 0,
                        marginLeft: "12px"
                      }}
                    >
                      <i className="fa fa-calendar-week" style={{ fontSize: "20px", color: "#ffffff" }}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6" style={{ display: "flex" }}>
              <div 
                className="card shadow-sm"
                style={{
                  borderRadius: "12px",
                  border: "none",
                  background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                  color: "#ffffff",
                  overflow: "hidden",
                  position: "relative",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  cursor: "pointer",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 8px 16px rgba(59, 130, 246, 0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
                }}
              >
                <div style={{ position: "absolute", top: "-15px", right: "-15px", width: "80px", height: "80px", background: "rgba(255, 255, 255, 0.1)", borderRadius: "50%" }}></div>
                <div className="card-body p-3" style={{ position: "relative", zIndex: 1, flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div style={{ flex: 1 }}>
                      <h6 
                        style={{
                          fontSize: "11px",
                          fontWeight: "600",
                          color: "rgba(255, 255, 255, 0.85)",
                          marginBottom: "6px",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px"
                        }}
                      >
                        Planned Leave This Month
                      </h6>
                      <h4 
                        style={{
                          fontSize: "28px",
                          fontWeight: "700",
                          color: "#ffffff",
                          marginBottom: 0,
                          lineHeight: "1.1"
                        }}
                      >
                        {leaveSummary?.planned_leaves_this_month || 0}
                      </h4>
                    </div>
                    <div 
                      style={{
                        width: "44px",
                        height: "44px",
                        borderRadius: "10px",
                        background: "rgba(255, 255, 255, 0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backdropFilter: "blur(10px)",
                        flexShrink: 0,
                        marginLeft: "12px"
                      }}
                    >
                      <i className="fa fa-calendar" style={{ fontSize: "20px", color: "#ffffff" }}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6" style={{ display: "flex" }}>
              <div 
                className="card shadow-sm"
                style={{
                  borderRadius: "12px",
                  border: "none",
                  background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                  color: "#ffffff",
                  overflow: "hidden",
                  position: "relative",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  cursor: "pointer",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 8px 16px rgba(211, 0, 26, 0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
                }}
              >
                <div style={{ position: "absolute", top: "-15px", right: "-15px", width: "80px", height: "80px", background: "rgba(255, 255, 255, 0.1)", borderRadius: "50%" }}></div>
                <div className="card-body p-3" style={{ position: "relative", zIndex: 1, flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div style={{ flex: 1 }}>
                      <h6 
                        style={{
                          fontSize: "11px",
                          fontWeight: "600",
                          color: "rgba(255, 255, 255, 0.85)",
                          marginBottom: "6px",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px"
                        }}
                      >
                        Pending Request
                      </h6>
                      <h4 
                        style={{
                          fontSize: "28px",
                          fontWeight: "700",
                          color: "#ffffff",
                          marginBottom: 0,
                          lineHeight: "1.1"
                        }}
                      >
                        {leaveSummary?.pending_request || 0}
                      </h4>
                    </div>
                    <div 
                      style={{
                        width: "44px",
                        height: "44px",
                        borderRadius: "10px",
                        background: "rgba(255, 255, 255, 0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backdropFilter: "blur(10px)",
                        flexShrink: 0,
                        marginLeft: "12px"
                      }}
                    >
                      <i className="fa fa-clock" style={{ fontSize: "20px", color: "#ffffff" }}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* {user.role?.access_scope !== "self" && ( */}
            <div className="row">
              <EmployeeLeaveFilter
                filters={filters}
                handleInputChange={handleInputChange}
                searchPlaceholder={"Search leave"}
                handleFilterDrawer={handleFilterDrawer}
                handleFilterChange={handleFilterChange}
                loading={loading}
                leaveTypes={leaveTypes}
                appliedFilterCount={appliedFilterCount}
                exportApiFn={exportLeaveListApi}
                exportParams={{
                  sort_by: pageSettings?.sortBy,
                  sort_type: pageSettings?.sortType,
                  ...getFilterParams(),
                }}
                exportFilename="Leaves.xlsx"
              />
            </div>
          {/* )} */}

          {view == "grid" ? (
            <div className="row">
              <style>{`
                @media (max-width: 768px) {
                  .row > .col-xxl-3,
                  .row > .col-xl-4,
                  .row > .col-md-6 {
                    padding-right: 0.5rem !important;
                    padding-left: 0.5rem !important;
                    margin-bottom: 0.75rem !important;
                  }
                }
              `}</style>
              {/* <div className="my-2" >
            <SearchBox handleChange={handleGridChange} pageSettings={pageSettings} setPageSettings={setPageSettings} />
            
            </div> */}
              <GridView />

              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  
                  <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            className="btn btn-primary"
                            label="Load More"
                            style={{ background: primaryRedGradient, border: "none" }}
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <style>{`
                    .modern-table .ant-table-tbody > tr {
                      background-color: #ffffff !important;
                    }
                    .modern-table .ant-table-tbody > tr:hover > td {
                      background-color: #f5f5f5 !important;
                    }
                    .modern-table .ant-table-thead > tr > th {
                      background-color: #f8f9fa !important;
                      font-weight: 600;
                      color: #333;
                      border-bottom: 2px solid #e0e0e0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-tbody > tr > td {
                      border-bottom: 1px solid #f0f0f0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                      border-top: 1px solid #f0f0f0;
                      background-color: #ffffff;
                      border-bottom-left-radius: 12px;
                      border-bottom-right-radius: 12px;
                    }
                  `}</style>
                  <div className="table-responsive" style={{ overflowX: "auto" }}>
                    <Table
                      className="mb-0 modern-table"
                      style={{ 
                        borderRadius: "12px",
                        minWidth: "100%"
                      }}
                      scroll={{ x: "max-content" }}
                      columns={columns}
                      dataSource={leaves}
                      rowKey={(record) => record.id}
                      loading={leavesLoading}
                      pagination={{
                        total: pageSettings?.total,
                        pageSize: pageSettings?.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: pageSizeOptions,
                        itemRender: itemRender,
                        position: "right",
                        current: pageSettings?.page,
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${total} items`,
                        style: { padding: "16px" }
                      }}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Add Leave Modal */}
      <EmployeeLeaveModelPopup
        fetchLeaveList={fetchLeaveList}
        selectedLeave={selectedLeave}
        setSelectedLeave={setSelectedLeave}
        leaveTypes={leaveTypes}
        leaveModal={leaveModal}
        setLeaveModal={setLeaveModal}
        user={user}
      />
      {/* Add Leave Modal */}
      {/* Delete Modal */}
      <DeleteModal Name="Delete Leaves" />
      {/* Delete Modal */}

      <FilterDrawer
        searchPlaceholder={"Search leave"}
        showFilterDrawer={showFilterDrawer}
        handleFilterDrawer={handleFilterDrawer}
        handleFilterChange={handleFilterChange}
        filters={filters}
        handleInputChange={handleInputChange}
        handleApplyFilter={handleApplyFilter}
        filterLoading={filterLoading}
        handleDateChange={handleDateChange}
        leaveTypes={leaveTypes}
      />
    </>
  );
};

export default EmployeeLeave;
